module.exports = __webpack_public_path__ + "img/back_inseam.7e654f1e.png";